// Check if the custom element 'product-card' is already defined
if (!customElements.get("product-card")) {
  /**
   * ProductCard is a custom HTML element that handles colour swatch hover events.
   * When hovering over a swatch, it updates the product image to a secondary image
   * specified in the swatch's `data-second-image` attribute. The image will revert back
   * to hidden when the hover ends.
   */
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatchElements = []; // To store swatch elements
      this.swatchImageElement = null; // To store the image element to be updated
    }

    connectedCallback() {
      // Fetch all elements within the product card that have the 'data-colour-swatch' attribute
      this.swatchElements = this.querySelectorAll("[data-colour-swatch]");

      // Fetch the image element that should display the second image on hover
      this.swatchImageElement = this.querySelector("img[data-swatch-image]");

      // Ensure both swatch elements and the image element exist before proceeding
      if (this.swatchElements.length === 0 || !this.swatchImageElement) {
        console.warn("ProductCard: No swatches or swatch image found.");
        return;
      }

      // Add event listeners to each swatch for hover effects
      this.addSwatchEventListeners();
    }

    addSwatchEventListeners() {
      this.swatchElements.forEach((swatch) => {
        swatch.addEventListener("mouseenter", (event) =>
          this.handleSwatchHover(event),
        );
        swatch.addEventListener("mouseleave", () => this.hideSwatchImage());
      });
    }

    handleSwatchHover(event) {
      const swatch = event.currentTarget;
      const secondImageUrl = swatch.getAttribute("data-second-image");

      if (!secondImageUrl) {
        console.warn(
          "ProductCard: Swatch does not have a data-second-image attribute.",
        );
        return;
      }

      this.swatchImageElement.src = secondImageUrl;
      this.swatchImageElement.classList.remove("hidden");
    }

    hideSwatchImage() {
      this.swatchImageElement.classList.add("hidden");
    }
  }

  // Register the custom element <product-card> only if it hasn't been registered already
  customElements.define("product-card", ProductCard);
}
